import {FC} from "react";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const ConfirmationModal: FC<{text: string, confirmText?: string, onConfirmed: () => Promise<void>}> = (props) => {
  return <div className={"flex flex-col space-y-3"}>
    <div>{props.text}</div>
    <ModalFooter text={props.confirmText ?? 'Ja'} onSubmit={props.onConfirmed} />
  </div>
}